(() => {
  const desktopSelector = '[data-sm-desktop-menu]';
  const desktopMenus = () => [...document.querySelectorAll(desktopSelector)];
  function selectCategory(tab, focus = false) {
    const browser = tab.closest('[data-sm-category-browser]');
    browser.querySelectorAll('[role="tab"]').forEach(other => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;
      browser.querySelectorAll('[role="tabpanel"]').forEach(panel => {
        if (panel.id === other.getAttribute('aria-controls')) panel.hidden = !selected;
      });
    });
    if (focus) tab.focus();
  }
  document.addEventListener('toggle', event => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.matches(desktopSelector)) return;
    item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
    if (item.open) desktopMenus().forEach(other => { if (other !== item) other.open = false; });
  }, true);
  document.addEventListener('focusout', event => {
    const item = event.target.closest(desktopSelector);
    if (item && !item.contains(event.relatedTarget)) item.open = false;
  });
  document.addEventListener('click', event => {
    const tab = event.target.closest('.sm-category-tab');
    if (tab) selectCategory(tab);
    const opener = event.target.closest('[data-sm-open]');
    if (opener) {
      const navigation = opener.closest('[data-sm-mobile-navigation]');
      const target = [...navigation.querySelectorAll('[data-sm-screen]')].find(screen => screen.dataset.smScreen === opener.dataset.smOpen);
      if (target) {
        event.preventDefault();
        navigation.querySelectorAll('[data-sm-screen]').forEach(screen => { screen.hidden = screen !== target; });
        target.querySelector('h2').focus({ preventScroll: true });
        navigation.closest('[data-drawer]').scrollTop = 0;
      }
    }
    desktopMenus().forEach(item => { if (!item.contains(event.target)) item.open = false; });
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('.sm-category-tab');
    if (tab && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
      const tabs = [...tab.closest('[role="tablist"]').querySelectorAll('[role="tab"]')];
      const index = tabs.indexOf(tab);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + tabs.length) % tabs.length;
      event.preventDefault();
      selectCategory(tabs[next], true);
    }
    if (event.key !== 'Escape') return;
    const item = event.target.closest(desktopSelector);
    if (item && item.open) { item.open = false; item.querySelector('summary').focus(); event.preventDefault(); }
  });
  window.matchMedia('(min-width: 1024px)').addEventListener('change', () => {
    desktopMenus().forEach(item => { item.open = false; });
  });
})();

/* Match sticky offsets to the actual two-row desktop header. */
(() => {
 let observer;
 const desktop = window.matchMedia('(min-width: 1024px)');
 const properties = ['--header-height','--header-sticky-height','--header-background-height'];
 function attach() {
  if (observer) observer.disconnect();
  const header = document.querySelector('.sm-navigation-header');
  const wrapper = header && header.querySelector(':scope > .wrapper');
  if (!header || !wrapper || !desktop.matches) {
   properties.forEach(property => document.documentElement.style.removeProperty(property));
   return;
  }
  let fullHeight = 0;
  function measure() {
   const height = Math.ceil(wrapper.getBoundingClientRect().height);
   if (!height) return;
   fullHeight = Math.max(fullHeight, height);
   const root = document.documentElement.style;
   root.setProperty('--header-height', fullHeight + 'px');
   root.setProperty('--header-background-height', height + 'px');
   root.setProperty('--header-sticky-height', header.hasAttribute('data-header-sticky') ? height + 'px' : '0px');
  }
  observer = new ResizeObserver(measure);
  observer.observe(wrapper);
  measure();
 }
 desktop.addEventListener('change', attach);
 document.addEventListener('shopify:section:load', attach);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, {once:true});
 else attach();
})();

/* Keep the collection banner jump clear of the sticky header. */
document.addEventListener('click', event => {
 const link = event.target.closest('a[href="#AjaxinateLoop"]');
 if (!link || !link.closest('[id$="__blocks_p4aDqx"]')) return;
 const products = document.getElementById('AjaxinateLoop');
 if (!products) return;
 event.preventDefault();
 event.stopImmediatePropagation();
 const height = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
 window.scrollTo({top: products.getBoundingClientRect().top + window.scrollY - height - 16, behavior:'smooth'});
}, true);
